var render = function render(){
  var _vm$processData, _vm$processData2, _vm$processData3, _vm$processData3$fiel, _vm$processData4, _vm$processData5, _vm$processData6, _vm$processData7, _vm$processData8, _vm$processData9, _vm$processData10, _vm$processData11, _vm$processData12, _vm$processData13, _vm$processData14, _vm$processData14$use, _vm$processData15, _vm$processData15$col, _vm$processData16, _vm$protocolList, _vm$processData17, _vm$protocolList2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layer_pop_wrap"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    style: _vm.active ? 'display: block;' : 'display: none'
  }), _c('div', {
    staticClass: "layer_pop",
    class: _vm.active ? 'active' : '',
    attrs: {
      "data-role-popup": "modal_01",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v("포함된 프로토콜")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])]), _c('div', {
    staticClass: "pop_cont"
  }, [_c('div', {
    staticClass: "protocol_search_item"
  }, [_c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "txt_cont"
  }, [_c('div', {
    staticClass: "tit_label"
  }, [(_vm$processData = _vm.processData) !== null && _vm$processData !== void 0 && _vm$processData.uniqueNumber ? _c('span', {
    staticClass: "label_color color_01",
    domProps: {
      "innerHTML": _vm._s((_vm$processData2 = _vm.processData) === null || _vm$processData2 === void 0 ? void 0 : _vm$processData2.uniqueNumber)
    }
  }) : _c('span', {
    staticClass: "label_color color_01",
    domProps: {
      "innerHTML": _vm._s('공정도')
    }
  }), _c('span', {
    staticClass: "label_gray"
  }, [_vm._v(_vm._s(`${(_vm$processData3 = _vm.processData) === null || _vm$processData3 === void 0 ? void 0 : (_vm$processData3$fiel = _vm$processData3.fieldName) === null || _vm$processData3$fiel === void 0 ? void 0 : _vm$processData3$fiel.split(">").join(" / ")}`))])]), _vm.$props.searchFlag === true ? _c('a', {
    staticClass: "tit_link",
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(!((_vm$processData4 = _vm.processData) !== null && _vm$processData4 !== void 0 && _vm$processData4.processName) ? (_vm$processData5 = _vm.processData) === null || _vm$processData5 === void 0 ? void 0 : _vm$processData5.name : (_vm$processData6 = _vm.processData) === null || _vm$processData6 === void 0 ? void 0 : _vm$processData6.processName)
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  }) : _c('div', {
    staticClass: "tit_link",
    domProps: {
      "innerHTML": _vm._s(!((_vm$processData7 = _vm.processData) !== null && _vm$processData7 !== void 0 && _vm$processData7.processName) ? (_vm$processData8 = _vm.processData) === null || _vm$processData8 === void 0 ? void 0 : _vm$processData8.name : (_vm$processData9 = _vm.processData) === null || _vm$processData9 === void 0 ? void 0 : _vm$processData9.processName)
    }
  })]), _c('div', {
    staticClass: "img_cont"
  }, [_vm.$props.searchFlag === true ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    staticClass: "template",
    attrs: {
      "src": ((_vm$processData10 = _vm.processData) === null || _vm$processData10 === void 0 ? void 0 : _vm$processData10.thumbnail) != null ? `data:image/jpeg;base64,${(_vm$processData11 = _vm.processData) === null || _vm$processData11 === void 0 ? void 0 : _vm$processData11.thumbnail}` : ''
    }
  })])]) : _c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    staticClass: "template",
    attrs: {
      "src": ((_vm$processData12 = _vm.processData) === null || _vm$processData12 === void 0 ? void 0 : _vm$processData12.thumbnail) != null ? `data:image/jpeg;base64,${(_vm$processData13 = _vm.processData) === null || _vm$processData13 === void 0 ? void 0 : _vm$processData13.thumbnail}` : ''
    }
  })])])]), _c('div', {
    staticClass: "bottom_info"
  }, [_c('ul', {
    staticClass: "user_set"
  }, [_c('li', [_vm._v(_vm._s(_vm.lastEditDate))]), _c('li', [_vm._v("책임작성자 : " + _vm._s((_vm$processData14 = _vm.processData) === null || _vm$processData14 === void 0 ? void 0 : (_vm$processData14$use = _vm$processData14.userData) === null || _vm$processData14$use === void 0 ? void 0 : _vm$processData14$use.name))]), (_vm$processData15 = _vm.processData) !== null && _vm$processData15 !== void 0 && (_vm$processData15$col = _vm$processData15.collaborators) !== null && _vm$processData15$col !== void 0 && _vm$processData15$col.length ? _c('li', [_vm._v("공동작성자 : "), _vm._l((_vm$processData16 = _vm.processData) === null || _vm$processData16 === void 0 ? void 0 : _vm$processData16.collaborators, function (collaborator, collaboratorKey) {
    return _c('span', {
      key: collaboratorKey
    }, [_vm._v(_vm._s(`${collaboratorKey != 0 ? " ," + collaborator.name : collaborator.name}`))]);
  })], 2) : _vm._e()])])]), _c('div', {
    staticClass: "include_protocol_tit"
  }, [_c('span', [_vm._v("포함된 프로토콜 "), _c('strong', [_vm._v(_vm._s(!((_vm$protocolList = _vm.protocolList) !== null && _vm$protocolList !== void 0 && _vm$protocolList.length) ? (_vm$processData17 = _vm.processData) === null || _vm$processData17 === void 0 ? void 0 : _vm$processData17.protocolCount : (_vm$protocolList2 = _vm.protocolList) === null || _vm$protocolList2 === void 0 ? void 0 : _vm$protocolList2.length))]), _c('em', [_vm._v("건")])])]), _c('div', {
    staticClass: "include_protocol_list"
  }, _vm._l(_vm.computedProtocolList, function (category, categoryKey) {
    var _category$0$get, _category$0$get2, _category$0$get3, _category$0$get4, _category$;

    return _c('dl', {
      key: categoryKey,
      staticClass: "include_protocol_accodian",
      class: _vm.accodianSelection.includes(categoryKey) ? 'open' : null
    }, [_c('dt', {
      on: {
        "click": function ($event) {
          return _vm.accodianSelectionFor(categoryKey);
        }
      }
    }, [_c('ul', {
      staticClass: "include_protocol_label"
    }, [((_category$0$get = category[0].get('material')) === null || _category$0$get === void 0 ? void 0 : _category$0$get.trim().length) != 0 ? _c('li', {
      staticClass: "label_01"
    }, [_c('span', [_vm._v(_vm._s(category[0].get('material')))])]) : _vm._e(), ((_category$0$get2 = category[0].get('measurement')) === null || _category$0$get2 === void 0 ? void 0 : _category$0$get2.trim().length) != 0 ? _c('li', {
      staticClass: "label_02"
    }, [_c('span', [_vm._v(_vm._s(category[0].get("measurement")))])]) : _vm._e(), ((_category$0$get3 = category[0].get('analysis')) === null || _category$0$get3 === void 0 ? void 0 : _category$0$get3.trim().length) != 0 ? _c('li', {
      staticClass: "label_04"
    }, [_c('span', [_vm._v(_vm._s(category[0].get("analysis")))])]) : _vm._e(), ((_category$0$get4 = category[0].get('equipment')) === null || _category$0$get4 === void 0 ? void 0 : _category$0$get4.trim().length) != 0 ? _c('li', {
      staticClass: "label_03"
    }, [_c('span', [_vm._v(_vm._s(category[0].get("equipment")))])]) : _vm._e()]), _c('strong', {
      staticClass: "protocol_num"
    }, [_vm._v("Protocol (" + _vm._s((_category$ = category[1]) === null || _category$ === void 0 ? void 0 : _category$.length) + ")")])]), _c('dd', [_c('ul', {
      staticClass: "include_protocol_accodian_list"
    }, _vm._l(category[1], function (protocol, protocolKey) {
      var _protocol$releaseDate, _protocol$revisionDat, _protocol$createdDate, _protocol$updatedDate, _protocol$user;

      return _c('li', {
        key: protocolKey
      }, [_c('div', {
        staticClass: "protocol_search_item"
      }, [_c('div', {
        staticClass: "top_info"
      }, [_c('div', {
        staticClass: "txt_cont"
      }, [_c('div', {
        staticClass: "tit_label"
      }, [protocol.uniqueNumber ? _c('span', {
        staticClass: "label_color color_02"
      }, [_vm._v(_vm._s(protocol.protocolType)), _c('em', [_vm._v("|")]), _vm._v(_vm._s(protocol.uniqueNumber))]) : _c('span', {
        staticClass: "label_color color_02"
      }, [_vm._v(_vm._s(protocol.protocolType))]), _c('span', {
        staticClass: "label_gray"
      }, [_vm._v(_vm._s(`${protocol === null || protocol === void 0 ? void 0 : protocol.fieldName.split(">").join(" / ")}`))])]), _c('a', {
        staticClass: "tit_link",
        attrs: {
          "href": "javascript:void(0);"
        },
        domProps: {
          "innerHTML": _vm._s(protocol.name)
        },
        on: {
          "click": function ($event) {
            return _vm.goToDetail(protocol, 'tree', 1);
          }
        }
      })])]), _c('div', {
        staticClass: "bottom_info"
      }, [_c('ul', {
        staticClass: "user_set"
      }, [_vm.publishingActive ? _c('li', [_vm._v(" " + _vm._s(`${!(protocol !== null && protocol !== void 0 && protocol.revisionDate) ? protocol === null || protocol === void 0 ? void 0 : (_protocol$releaseDate = protocol.releaseDate) === null || _protocol$releaseDate === void 0 ? void 0 : _protocol$releaseDate.substring(0, 10).split('-').join('.') : protocol === null || protocol === void 0 ? void 0 : (_protocol$revisionDat = protocol.revisionDate) === null || _protocol$revisionDat === void 0 ? void 0 : _protocol$revisionDat.substring(0, 10).split('-').join('.')}`) + " ")]) : _c('li', [_vm._v(" " + _vm._s(`${!(protocol !== null && protocol !== void 0 && protocol.updatedDate) ? protocol === null || protocol === void 0 ? void 0 : (_protocol$createdDate = protocol.createdDate) === null || _protocol$createdDate === void 0 ? void 0 : _protocol$createdDate.substring(0, 10).split('-').join('.') : protocol === null || protocol === void 0 ? void 0 : (_protocol$updatedDate = protocol.updatedDate) === null || _protocol$updatedDate === void 0 ? void 0 : _protocol$updatedDate.substring(0, 10).split('-').join('.')}`) + " ")]), _c('li', [_vm._v("책임작성자 : " + _vm._s(protocol === null || protocol === void 0 ? void 0 : (_protocol$user = protocol.user) === null || _protocol$user === void 0 ? void 0 : _protocol$user.userName))]), protocol !== null && protocol !== void 0 && protocol.collaborators.length ? _c('li', [_vm._v("공동작성자 : "), _vm._l(protocol === null || protocol === void 0 ? void 0 : protocol.collaborators, function (collaborator, collaboratorKey) {
        var _collaborator$userNam, _collaborator$userNam2;

        return _c('span', {
          key: collaboratorKey
        }, [_vm._v(_vm._s(`${collaboratorKey != 0 ? " ," + ((_collaborator$userNam = collaborator.userName) !== null && _collaborator$userNam !== void 0 ? _collaborator$userNam : collaborator.name) : (_collaborator$userNam2 = collaborator.userName) !== null && _collaborator$userNam2 !== void 0 ? _collaborator$userNam2 : collaborator.name}`))]);
      })], 2) : _vm._e()]), _c('ul', {
        staticClass: "btn_set"
      }, [_c('li', [_c('a', {
        staticClass: "tree_btn",
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function ($event) {
            return _vm.goToDetail(protocol, 'tree', 1);
          }
        }
      }, [_vm._v("트리보기")])]), _c('li', [_c('a', {
        staticClass: "wiki_btn",
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function ($event) {
            return _vm.goToDetail(protocol, 'wiki', 1);
          }
        }
      }, [_vm._v("위키보기")])])])])])]);
    }), 0)])]);
  }), 0)]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }